import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);
import Scrollspy from 'react-scrollspy';
import Slider from '../components/Slider';
import WindowBrowser from "../components/browser-window";



const Elona = () => {
  const headers = ['Elona'];




  useEffect(() => {


  }, [])

  return (
    <div className="simple_page">
      <div className="mainIntro">
        <h1>ELONA </h1>
        <h3>Spot the fake. Safeguard the cure.</h3>
      </div>
      <section className="divider">
        <div className="fixed_sidebar">
          <div className="sidebar">
            <div className="main_sidebar">
              ELONA
            </div>
            {/* <Scrollspy
              offset={-140}
              className="scrollspy" items={
                headers.map(header => {
                  return header.split(' ')[0]
                })
              }
              currentClassName="active">
              {
                headers.map(header => {

                  return (
                    <li><a href={"#" + header.split(' ')[0]}>{
                      header.replace('_', '')
                    }</a></li>
                  )

                })
              }
            </Scrollspy> */}

            <Scrollspy
              offset={-140}
              className="scrollspy" items={['Method', 'Protocol', 'Discussion', 'References']}
              currentClassName="active">
              <li><a href="#Method">Method Description</a></li>
              <li><a href="#Protocol">Protocol</a></li>
              <li><a href="#Discussion">Discussion</a></li>

              <li><a href="#References">References</a></li>



            </Scrollspy>
            <img
              src="https://static.igem.wiki/teams/5334/wiki-images/updated-mascot/mascot-holding-flask-3-1.webp"
              alt="Mascot woth flask"

            />
          </div>

        </div>
        <div className="main_lab_style">
          <WindowBrowser description={
            <div>
              <div style={{ display: 'none' }}>
                {
                  headers.map(header => {
                    return (
                      <section href={header.split(' ')[0]}>{
                        header
                      }</section>
                    )

                  })
                }
              </div>
              <div>
                <section id="Method">

                  <h1>
                    Method Description
                  </h1>

                  <p>
                    The Enzyme-Linked Oligonucleotide Assay (ELONA) is an innovative bioanalytical method that replaces traditional antibodies with aptamers, short single-stranded DNA or RNA molecules, as the recognition element. In this assay, aptamers bind to specific target molecules, and the detection is facilitated through enzyme-linked conjugates, similar to ELISA but with increased specificity and stability due to the properties of aptamers [1,2]. ELONA is particularly effective in analyzing interactions at femtomolar concentrations, making it a sensitive, specific, and versatile approach (Fig. 1). The method provides a fluorescent or colorimetric readout when aptamers bind to their target, such as Bevacizumab, enabling simultaneous analysis of multiple analytes. This makes ELONA an essential tool for selecting aptamers with the highest binding affinity from a large pool of candidates [4].
                  </p>

                  <img src="https://static.igem.wiki/teams/5334/wiki-images/lab/schematic-fig1.jpg">
                  </img>

                  <p>
                    <strong>Figure 1. </strong> Principle of ELONA technique for Bevacizumab detection                  
                  </p>

                </section>
              </div>
              <section id="Protocol">
                <br />

                <h1>
                  Protocol
                </h1>
                <p>
                  The process begins with the preparation of a 96-well polypropylene microtiter plate. To perform the assay, prepare the bevacizumab aptamer in 50 mM PBS with 1 mM EDTA, pH 8.5, at a final concentration of 1 µM. Dispense 100 µL of the aptamer solution into each well of the plate, incubating it for 2 hours. After incubation, remove the solution, wash each well 3 times with 200 µL PBST (PBS + 0.05% Tween 20), shaking for 30 seconds with each wash. Following the washes,  each well is coated with 200 μL of 5% (w/v) bovine serum albumin (BSA) in phosphate-buffered saline (PBS) to block non-specific binding sites. This step is crucial to ensure that only specific interactions are measured [3]. Next, Bevacizumab in PBS with 0.1 % (w/v) BSA solution as the target analyte is immobilized on substratum of the wells via incubating for 2 hours at room temperature. After immobilization, the supernatant is carefully removed to retain the target. This step is followed by a 3 times washing process.
                </p>
                <p>
                  The binding phase confers the incubation of candidate aptamer oligonucleotides to the 96-well plate. This solution is added to each well and incubated for 60 minutes to allow sufficient time for binding interactions to occur. Following the binding phase, each well is washed once with PBST buffer (PBS with Tween 20) to remove any unbound aptamers. This washing step is essential to reduce background noise and increase the assay's accuracy. Detection is achieved by adding 100 μL of a8000-fold diluted horseradish peroxidase-conjugated NeutrAvidin (NeutrAvidin-HRP; Thermo Fisher Scientific) solution in PBS to each well. The plate is then incubated at 37 C० for 1 hour to allow the detection reagent to bind effectively. Subsequent to the detection phase, each well undergoes three washing cycles with PBST buffer to ensure the removal of any non-specifically bound materials. This step is critical for maintaining the specificity of the assay. The chromogenic reaction involves adding the tetramethylbenzidine solution (1-Step™ TMB ELISA Substrate Solutions, Thermo Fisher Scientific) substrate to each well, followed by a 5-minute incubation period.  This step is crucial for developing the colorimetric signal that will be measured. Measurements of absorption at 450 nm wavelength reflect and report the intensity of the signal, providing a quantitative measure of the aptamer-target interactions, enabling precise analysis of aptamer performance [5].
                </p>
                <p>
                Statistical analysis. Statistical analysis was performed with unpaired two-tailed t-test using GraphPad Prism Software (GraphPad Software Inc., CA) with p &lt; 0.05 considered as significant (* p &lt; 0.05). Error bars represent standard error of the mean (SEM) of at least three independent reproducible biological experiments (Fig. 5).
                </p>

              </section>
              <section id="Discussion">
                <br />

                <h1>
                  Discussion
                </h1>
                <p>
                  To evaluate the binding affinity, we performed the binding of bevacizumab to the initial aptamer <strong>А14#1</strong> via ELONA (Fig. 2). We conducted a series of experiments to validate the method of chromogenic signal detection and establish a lower limit of Bevacizumab detection.
                </p>
                <p>
                  In our results, we observed that DNA aptamers, unlike monoclonal antibodies (mAbs) commonly used in ELISA methods, demonstrate high stability against factors such as heat, organic solvents, and acids. The chemical modification of the DNA aptamers on the microplate surface remained stable as well. By maintaining proper washing protocols and preserving the three-dimensional structure of the aptamers, strong linearity of the calibration curves was achieved (r² &gt; 0.9847) (Fig.2)
                </p>
                <p>
                  However, lowering the concentration of bevacizumab in samples resulted in a reduction of the calibration curve's slope and increased variance in absorbance between bevacizumab samples. These issues likely stemmed from nonspecific adsorption of  IgG or other components to the plate surface, as well as working below the recommended detection limit of TMB. Despite this, the CV (coefficient of variation) values across all concentrations remained below 30%, demonstrating that some accuracy was maintained. The lowest detectable concentration was determined to be 0,005 μg/ml, which equals 0,5 ng.
                </p>


                <img src="https://static.igem.wiki/teams/5334/wiki-images/lab/calibration-curve.png"
                  style={{
                    transform: 'scale(0.8)',  // Scale image by 1.5 times
                    width: 'auto', // Adjust width as needed
                    height: 'auto', // Maintain aspect ratio
                    // marginTop: '10px', // Space between Scrollspy and image
                  }}
                ></img>

                <p>
                  <strong>Figure 2.</strong>  Calibration curve of colorimetric ELONA for bevacizumab samples.
                </p>

                <img src="https://static.igem.wiki/teams/5334/wiki-images/lab/lowest-cocn.png"
                  style={{
                    transform: 'scale(0.8)',  // Scale image by 1.5 times
                    width: 'auto', // Adjust width as needed
                    height: 'auto', // Maintain aspect ratio
                    // marginTop: '10px', // Space between Scrollspy and image
                  }}
                ></img>

                <p>
                  <strong>Figure 3.</strong> Lower limit of detection of Bevacizumab in samples (A14#1)
                </p>

                <br />
                <p>
                  After obtaining data from the initial aptamer A14#1, we repeated the procedure with the optimized aptamer CU2#19. The optimizations were aimed at improving its binding affinity and specificity through molecular docking and dynamics simulations. The graph below (Fig. 4) presents the results of the ELONA assay, demonstrating the enhanced performance of CU2#19 in detecting Bevacizumab, showing improved sensitivity and precision across the tested concentration range.
                </p>

                <img
                  style={{
                    transform: 'scale(0.8)',  // Scale image by 1.5 times
                    width: 'auto', // Adjust width as needed
                    height: 'auto', // Maintain aspect ratio
                    // marginTop: '10px', // Space between Scrollspy and image
                  }}
                  src="https://static.igem.wiki/teams/5334/wiki-images/lab/cu2-19.png">
                </img>
                <p>
                  <strong>Figure 4.</strong> Lower limit of detection of Bevacizumab in samples (CU2#19)
                </p>

                
                <br />
                <p>
                  The graph for A14#1 (Fig. 3) shows a relatively linear trend but demonstrates a limited dynamic range and sensitivity across the tested Bevacizumab concentrations. The normalized absorbance values for A14#1 exhibit larger error bars, indicating higher variability between replicates, and a less distinct trend in response to increasing Bevacizumab concentrations. The confidence interval is also wider, which suggests lower precision and possibly weaker binding interaction at lower concentrations.
                </p>


  

                <br />
                <p>
                  In contrast, the graph for CU2#19 shows a significant improvement in both the trendline and overall sensitivity. The normalized absorbance values for CU2#19 increase more sharply with increasing Bevacizumab concentrations, demonstrating better discrimination between lower and higher concentrations. Additionally, the trendline is more consistent, and the error bars are smaller, reflecting improved reproducibility and tighter binding between the aptamer and the target.
                </p>
                <p>
                  The 95% confidence interval for CU2#19 is also narrower than for A14#1, indicating higher precision in the measurements. CU2#19’s improved detection limits and reduced variability suggest that the molecular docking and dynamics optimizations successfully enhanced the aptamer's binding affinity and specificity, particularly at lower Bevacizumab concentrations.
                </p>
                <p>
                Mutations introduced into the initial sequence have proven to be effective through the results of ELONA assay. CU2#19 has demonstrated improved performance over A14#1 which is evident from higher absorbance values over a range of concentrations, making it a promising aptamer for Bevacizumab detection.
                </p>
                  <br></br>

                <img
                  style={{
                    // transform: 'scale(0.8)',  // Scale image by 1.5 times
                    width: 'auto', // Adjust width as needed
                    height: 'auto', // Maintain aspect ratio
                    // marginTop: '10px', // Space between Scrollspy and image
                  }}
                  src="https://static.igem.wiki/teams/5334/wiki-images/lab/img1-2.webp">
                </img>

                <p>
                  <strong>Figure 5.</strong> Absorbance values of A14#1 and CU2#19 vs different Bevacizumab concentrations.
                </p>

                {/* <p>
                  ELONA offers a straightforward, label-free method for characterizing aptamer interactions. Its high sensitivity and specificity make it ideal for selecting aptamers with optimal binding affinities. The method's colorimetric and fluorescent outputs ensure clear visualizations that can be quantified, aiding in the precise analysis of aptamer binding capabilities.
                </p> */}
              </section>




              <section id="References">
                <br />
                <p>
                  <h1> References </h1>
                </p>
                <ol>
                  <li>
                  Song, S., Wang, L., Li, J., Fan, C. & Zhao, J. Aptamer-based biosensors. Trends Anal. Chem. 27, 108–117 (2008).
                  </li>


                  <li>
                  Toh, S. Y., Citartan, M., Gopinath, S. C. B. & Tang, T.-H. Aptamers as a replacement for antibodies in enzyme-linked immunosorbent assay. Biosens. Bioelectron. 64, 392–403 (2015).                  </li>
                  
                  <li>
                  Yamada, T. et al. High-throughput bioanalysis of bevacizumab in human plasma based on enzyme-linked aptamer assay using anti-idiotype DNA aptamer. Anal. Chem. (2019).

                  </li>
                  <li>
                  Saito, T. et al. Development of a DNA aptamer that binds to the complementarity-determining region of therapeutic monoclonal antibody and affinity improvement induced by pH-change for sensitive detection. Biosens. Bioelectron. 203, 114027 (2022).
                  </li>
                  <li>
                  Mairal, T., Ozalp, V. C., Sanchez, P. L., Mir, M., Katakis, I. & O’Sullivan, C. K. Aptamers: molecular tools for analytical applications. Anal. Bioanal. Chem. 390, 989–1007 (2008).
                  </li>


                </ol>
                <br></br>
                <br></br>
                <br></br>
                <br></br>


              </section>
            </div>
          } />
        </div>
      </section>
    </div>
  );
}


export default Elona;
